import {firebaseInstance as firebase} from "@/main";
import "firebase/auth";

export default {
	namespaced: true,
	actions: {
		login: ({commit}, user) => {
			return firebase.auth().signInWithEmailAndPassword(user.email, user.password);
		},
		loginAnonimus: ({commit}) => {
			return firebase.auth().signInAnonymously();
		},
		logout: ({commit}, to) => {
			commit("SET_LOGOUT");
			return firebase.auth().signOut();
		},

		isLogin({commit}, to) {
			firebase.auth().onAuthStateChanged((user) => {
				if (user) {
					commit(
						"setLogin",
						{
							username: user.displayName,
							email: user.email,
							active: user.emailVerified,
							role: "admin",
							token: user.uid,
							pic: user.photoURL,
						},
						{root: true}
					);
					to.app.$router.push("/dashboard");
					return user;
				} else {
					console.warn("isLogin: No user is signed in");
					return null;
				}
			});
		},

		isUserLoggedIn: () => {
			let isAuthenticated = false;
			// get firebase current user
			const firebaseCurrentUser = firebase.auth().currentUser;
			if (firebase.auth.isAuthenticated() || firebaseCurrentUser) isAuthenticated = true;
			return localStorage.getItem("userInfo") && isAuthenticated;
		},

		signInWithEmail: ({commit}, user) => {
			return firebase.auth().createUserWithEmailAndPassword(user.email, user.password);
		},

		signInWithGoogle: ({commit}, options) => {
			const provider = new firebase.auth.GoogleAuthProvider();
			provider.addScope("https://www.googleapis.com/auth/contacts.readonly");
			firebase.auth().languageCode = options.locale || "en";

			provider.setCustomParameters({
				login_hint: "user@example.com",
			});
			return firebase.auth().signInWithPopup(provider);
		},

		signInWithTwitter: ({commit}, options) => {
			const provider = new firebase.auth.TwitterAuthProvider();
			firebase.auth().languageCode = options.locale || "en";
			provider.setCustomParameters({
				lang: options.locale || "en",
				login_hint: "@exampleUser",
			});

			return firebase.auth().signInWithPopup(provider);
		},

		signInWithGithub: ({commit}, options) => {
			const provider = new firebase.auth.GithubAuthProvider();
			firebase.auth().languageCode = options.locale || "en";
			provider.setCustomParameters({
				lang: options.locale || "en",
			});

			return firebase.auth().signInWithPopup(provider);
		},

		signInWithFacebook: ({commit}, options) => {
			const provider = new firebase.auth.FacebookAuthProvider();
			firebase.auth().languageCode = options.locale || "en";
			provider.setCustomParameters({
				lang: options.locale || "en",
			});

			return firebase.auth().signInWithPopup(provider);
		},

		register({commit}, user) {
			//deprecated now using BackEnd Endpoint
			console.warn("deprecated, please to use BackEnd Endpoint");
			return firebase.auth().createUserWithEmailAndPassword(user.email, user.password);
		},

		delete({commit}, uid) {
			//deprecated now using BackEnd Endpoint
			console.warn("deprecated, please to use BackEnd Endpoint");
			return firebase.auth().delete(uid);
		},
	},
};
